import { render, staticRenderFns } from "./fire_alarm_history_datatable.vue?vue&type=template&id=1bc33ff0&"
import script from "./fire_alarm_history_datatable.vue?vue&type=script&lang=js&"
export * from "./fire_alarm_history_datatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports